<template>
	<transition name="fade" mode="out-in">
		<slot
			v-if="!connected"
			name="default"
			:connect="connect"
			:metamask="metamask"
			:present="present"
			:connecting="connecting"
		></slot>
		<slot v-else name="connected" :wallet="metamask.state.wallet" :metamask="metamask" />
	</transition>
</template>
<script lang="ts" setup>
import { computed, onMounted, onUnmounted } from 'vue'
import metamask from '@/util/metamask'
import { discoverProvider } from '@/util/walletProvider'

const $emit = defineEmits(['connected'])

const connected = computed(() => metamask.state.connected)
const present = computed(() => metamask.state.present)
const connecting = computed(() => metamask.state.connecting)

function onConnected(payload: { wallet: string }) {
	$emit('connected', payload?.wallet ?? metamask.state.wallet)
}

onMounted(async () => {
	metamask.on('connected', onConnected)

	const provider = await discoverProvider()
	if (provider) {
		metamask.init(provider)
	}
})

onUnmounted(() => {
	metamask.off('connected', onConnected)
})

async function connect() {
	return metamask.connect()
}
</script>
